import { YearsService } from '@/services/years.service'

export default {
  getList ({ commit }) {
    return YearsService.list()
      .then(years => {
        console.log(years)
        commit('SET_YEAR_LIST', years)
        commit('SET_YEAR_SELECTED', years[years.length - 1])
      })
  }
}
